import styled from 'styled-components';

import { typography } from '@theme/font';
import { OFFSET } from '@theme/helpers';

export const TalkToExpertTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #333;
  text-align: center;
  padding:10px;
  margin-top: 36px;
`;

export const TalkToExpertTitleMobile = styled.div`
  ${typography({})};
  padding-bottom: ${OFFSET.XS};
  text-transform: uppercase;
  &:after {
    content: ':';
  }
`;

export const TalkToExpertFoldout = styled.ul`
  display: none;
  margin: 0 0 0 0;
  padding: 0;
`;

export const TalkToExpertFoldoutItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #333;
  text-align: center;
  padding:10px;
  cursor: pointer;
  text-decoration: none; 
  color: inherit;
`;

export const TalkToExpertItem = styled.span`
  ${typography({})};
  display: block;
  list-style: none;
  margin: 0 0 0 0;
  padding: 0;
  border: 1px solid #333;
  padding:10px;
  margin-top:10px;

  &:before {
    ${typography({})};
    margin-right: 8px;
  }
`;

export const Container = styled.div`
  &:hover,
  &:focus,
  &:focus-within {
    ${TalkToExpertFoldout} {
      display: block;
    }
  }
`;

export const MobileContainer = styled.div`
  padding: 30px 0;
  margin: 0 ${OFFSET.M};
  border-top: 1px solid black;
  border-bottom: 1px solid black;

  &:hover,
  &:focus,
  &:focus-within {
    ${TalkToExpertTitle} > span {
      border-bottom: 1px solid #000;
    }

    ${TalkToExpertFoldout} {
      display: block;
    }
  }
`;
